<template>
    <div class="detail">

        <div class="top">
            <div class="top-img">
                <img :src="mainInfo.storeLogo || require('@/assets/img/out-in-card/shop.jpg')">
            </div>
            <div class="top-info">
                <div class="info-name">{{ mainInfo.storeName }}</div>
                <div class="info-address">{{ mainInfo.plazaName }} {{ mainInfo.floor }}-{{ mainInfo.bunkDesc }}</div>
            </div>
        </div>

        <div class="bottom">
            <img class="status"
                :src="personInfo.valid == 1 ? require('@/assets/img/out-in-card/effect.png') : require('@/assets/img/out-in-card/uneffect.png')">
            <img class="status-img"
                :src="personInfo.valid == 1 ? require('@/assets/img/out-in-card/green.png') : require('@/assets/img/out-in-card/red.png')">
            <div class="to-detail" @click="handleDetail">查看详情</div>
            <div class="worker-info">
                <img class="face" :src="personInfo.bareheadedPhoto">
                <div class="name">{{ personInfo.name }}</div>
                <div class="address">{{ mainInfo.companyName }}</div>
                <div class="time">{{ personInfo.enterTime }} - {{ personInfo.enterEndTime }}</div>
                <!-- <img class="code" src="@/assets/img/out-in-card/code.png"> -->
                <VueQr class="code" :text="codeSrc" margin="0"></VueQr>
            </div>
        </div>

        <van-action-sheet v-model="showDetai" title="施工人详情">
            <div class="content">
                <div class="card">
                    <div class="card-title">施工人</div>
                    <van-cell title="姓名：" :value="personInfo.name" />
                    <van-cell title="公司名称：" :value="mainInfo.companyName" />
                    <van-cell title="现场负责人：" :value="mainInfo.renovationSceneContactsName" />
                    <van-cell title="负责人手机：" :value="mainInfo.renovationSceneContactsMobile" />
                </div>
                <div class="card">
                    <div class="card-title">施工时间</div>
                    <van-cell title="开始时间：" :value="personInfo.enterTime" />
                    <van-cell title="结束时间：" :value="personInfo.enterEndTime" />
                </div>
                <div class="card">
                    <div class="card-title">施工人附件</div>
                    <van-cell title="身份证正面：">
                        <template>
                            <span class="open-btn" @click="openCard(personInfo.frontIdCard)">打开</span>
                        </template>
                    </van-cell>
                    <van-cell title="身份证背面：">
                        <template>
                            <span class="open-btn" @click="openCard(personInfo.backIdCard)">打开</span>
                        </template>
                    </van-cell>
                </div>
            </div>
        </van-action-sheet>

        <van-overlay class="card-overlay" :show="showCard" @click="showCard = false">
            <img class="card-img" :src="IdCardSrc">
        </van-overlay>
    </div>
</template>

<script>
import { apiGetDetail, scanCp, sg_app_login } from '@/api/outInCard.js';
import { Toast } from 'vant';
import VueQr from 'vue-qr'
import Cookies from 'js-cookie'
export default {
  components: {
    VueQr
  },
  computed: {
    id() {
      return this.$route.query.id
    },
    idNo() {
      return this.$route.query.idNo
    },
  },
  data() {
    return {
      mainInfo: {},
      showDetai: false,
      showCard: false,
      codeSrc: location.href,
      IdCardSrc: '',
      personInfo: {}
    }
  },
  methods: {
    async scanCp() {
            // let user = await this.$bsUtils.nativeApi.getUserInfo() || {}
            // let data = {
            //     personId: this.id,
            //     userId: user.userId
            // }

      let user = {}
      let res = await this.$bsUtils.nativeApi.getUserInfo()

      if (typeof res == 'object') {
        user = res
      }

      if (Cookies.get('accessToken')) {
        let sg_user = await sg_app_login({ token: Cookies.get('accessToken') })
        user.userId = sg_user.code
      }



      let data = {

        personId: this.personInfo.id,
        userId: user.userId || ''
      }

      scanCp(data)
    },
    getCardDisabled(endTime) {
            // 判断出入证是否过期
      return new Date().getTime() > endTime ? true : false
    },
    async getDetail() {
      let data = {
        id: this.id,
        idNo: this.idNo
      }
      this.$toast.loading({
        message: '加载中...',
        duration: 0
      })

      let res = await apiGetDetail(data)
      this.$toast.clear()
      this.mainInfo = res
      this.mainInfo.disabled = this.getCardDisabled(new Date(`${res.renovationEndTime} 23:59:59`).getTime())
      this.personInfo = res.constructionPersonnelList[0] || {}
            // this.mainInfo.bareheadedPhoto = res.constructionPersonnelList[0]?.bareheadedPhoto
    },
    handleDetail() {
      this.showDetai = true
    },
    openCard(src) {
      if (src) {
        this.showCard = true
        this.IdCardSrc = src
      } else {
        return this.$toast('未找到')
      }

    },
  },
  async mounted() {

    await this.getDetail()

    await this.scanCp()

        // if (Cookies.get('accessToken')) {
        //     let sg_user = await sg_app_login({ token: Cookies.get('accessToken') })
        //     console.log(sg_user);
        // }
  }

}
</script>

<style lang="less" scoped>
.detail {
    background-color: #F6F7FB;
    text-align: left;
    padding: 12px;
    line-height: 1;

    .top {
        padding: 12px;
        display: flex;
        background-color: #fff;
        border-radius: 8px;

        .top-img {
            width: 48px;
            height: 48px;
            border-radius: 4px;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .top-info {
            margin-left: 12px;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .info-name {
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #111111;
                line-height: 25px;
            }

            .info-address {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                line-height: 17px;
            }
        }
    }

    .bottom {
        display: flex;
        flex-direction: column;
        position: relative;

        .status {
            width: 97px;
            height: 44px;
            position: absolute;
            top: 0;
            left: 0;
        }


        .status-img {
            height: 80px;
        }

        .to-detail {
            border: 1px solid #fff;
            padding: 5px 7px;
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            position: absolute;
            right: 12px;
            top: 12px;
            border-radius: 50px;
        }

        .worker-info {
            position: relative;
            background-color: #fff;
            padding: 40px 0;
            text-align: center;

            .face {
                width: 92px;
                height: 92px;
                position: absolute;
                top: 0;
                left: 50%;
                transform: translate(-50%, -50%);
                border-radius: 50%;
            }

            .name {
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #111111;
                line-height: 25px;
                margin-top: 35px;
            }

            .address {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 17px;
                margin-top: 10px;
            }

            .time {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 17px;
                margin-top: 6px;
            }

            .code {
                width: 216px;
                height: 216px;
                margin-top: 30px;
            }
        }

    }
}

.content {
    background-color: #F6F7FB;
    padding: 12px;

    .card {
        border-radius: 8px;
        background-color: #fff;
        margin-bottom: 12px;

        .card-title {
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #111111;
            margin-left: 12px;
            padding-top: 16px;
        }

        .van-cell {
            .van-cell__title {
                text-align: right;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                margin-right: 5px;
                white-space: nowrap;
            }

            .van-cell__value {
                flex: 3;
                text-align: left;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
            }

            .open-btn {
                color: #FF6F00;
            }
        }
    }
}

.card-overlay {
    z-index: 9999;

    .card-img {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 95%;
        transform: translate(-50%, -50%);
    }
}
</style>
